var _mask;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBehaviorScore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 13.5H7.33325C7.05992 13.5 6.83325 13.2733 6.83325 13C6.83325 12.7267 7.05992 12.5 7.33325 12.5H13.9999C14.2733 12.5 14.4999 12.7267 14.4999 13C14.4999 13.2733 14.2733 13.5 13.9999 13.5Z",
    fill: "#84858D",
    style: {
      fill: "#84858D",
      fill: "color(display-p3 0.5176 0.5216 0.5529)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 8.83203H7.33325C7.05992 8.83203 6.83325 8.60536 6.83325 8.33203C6.83325 8.0587 7.05992 7.83203 7.33325 7.83203H13.9999C14.2733 7.83203 14.4999 8.0587 14.4999 8.33203C14.4999 8.60536 14.2733 8.83203 13.9999 8.83203Z",
    fill: "#84858D",
    style: {
      fill: "#84858D",
      fill: "color(display-p3 0.5176 0.5216 0.5529)",
      fillOpacity: 1
    }
  }), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_24972_47499",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 4.16797H7.33325C7.05992 4.16797 6.83325 3.9413 6.83325 3.66797C6.83325 3.39464 7.05992 3.16797 7.33325 3.16797H13.9999C14.2733 3.16797 14.4999 3.39464 14.4999 3.66797C14.4999 3.9413 14.2733 4.16797 13.9999 4.16797Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 4.16797H7.33325C7.05992 4.16797 6.83325 3.9413 6.83325 3.66797C6.83325 3.39464 7.05992 3.16797 7.33325 3.16797H13.9999C14.2733 3.16797 14.4999 3.39464 14.4999 3.66797C14.4999 3.9413 14.2733 4.16797 13.9999 4.16797Z",
    fill: "#84858D",
    style: {
      fill: "#84858D",
      fill: "color(display-p3 0.5176 0.5216 0.5529)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 2.66797H7.33325V5.66797H13.9999V2.66797ZM7.33325 2.66797C7.88835 2.66797 8.33325 3.11287 8.33325 3.66797H5.33325C5.33325 4.76973 6.23149 5.66797 7.33325 5.66797V2.66797ZM8.33325 3.66797C8.33325 4.22306 7.88835 4.66797 7.33325 4.66797V1.66797C6.23149 1.66797 5.33325 2.56621 5.33325 3.66797H8.33325ZM7.33325 4.66797H13.9999V1.66797H7.33325V4.66797ZM13.9999 4.66797C13.4448 4.66797 12.9999 4.22306 12.9999 3.66797H15.9999C15.9999 2.56621 15.1017 1.66797 13.9999 1.66797V4.66797ZM12.9999 3.66797C12.9999 3.11287 13.4448 2.66797 13.9999 2.66797V5.66797C15.1017 5.66797 15.9999 4.76973 15.9999 3.66797H12.9999Z",
    fill: "#84858D",
    style: {
      fill: "#84858D",
      fill: "color(display-p3 0.5176 0.5216 0.5529)",
      fillOpacity: 1
    },
    mask: "url(#path-3-inside-1_24972_47499)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66671 4.83427C2.54004 4.83427 2.41338 4.7876 2.31338 4.6876L1.64671 4.02094C1.45338 3.8276 1.45338 3.5076 1.64671 3.31427C1.84004 3.12094 2.16004 3.12094 2.35338 3.31427L2.66671 3.6276L4.31338 1.98094C4.50671 1.7876 4.82671 1.7876 5.02004 1.98094C5.21338 2.17427 5.21338 2.49427 5.02004 2.6876L3.02004 4.6876C2.92004 4.7876 2.79338 4.83427 2.66671 4.83427Z",
    fill: "#84858D",
    style: {
      fill: "#84858D",
      fill: "color(display-p3 0.5176 0.5216 0.5529)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66671 9.49833C2.54004 9.49833 2.41338 9.45167 2.31338 9.35167L1.64671 8.685C1.45338 8.49167 1.45338 8.17167 1.64671 7.97833C1.84004 7.785 2.16004 7.785 2.35338 7.97833L2.66671 8.29167L4.31338 6.645C4.50671 6.45167 4.82671 6.45167 5.02004 6.645C5.21338 6.83833 5.21338 7.15833 5.02004 7.35167L3.02004 9.35167C2.92004 9.45167 2.79338 9.49833 2.66671 9.49833Z",
    fill: "#84858D",
    style: {
      fill: "#84858D",
      fill: "color(display-p3 0.5176 0.5216 0.5529)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66671 14.1663C2.54004 14.1663 2.41338 14.1196 2.31338 14.0196L1.64671 13.353C1.45338 13.1596 1.45338 12.8396 1.64671 12.6463C1.84004 12.453 2.16004 12.453 2.35338 12.6463L2.66671 12.9596L4.31338 11.313C4.50671 11.1196 4.82671 11.1196 5.02004 11.313C5.21338 11.5063 5.21338 11.8263 5.02004 12.0196L3.02004 14.0196C2.92004 14.1196 2.79338 14.1663 2.66671 14.1663Z",
    fill: "#84858D",
    style: {
      fill: "#84858D",
      fill: "color(display-p3 0.5176 0.5216 0.5529)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehaviorScore);
export default __webpack_public_path__ + "static/media/behavior_score.d6257dbea5b2db14d068d759741970eb.svg";
export { ForwardRef as ReactComponent };